module.exports = __webpack_public_path__ + "static/media/plan2.68bc73cf.jpg";